.container {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 1rem;
  user-select: none;
}

.select {
  composes: slideRight from global;
}

.content {
  width: 100%;
}
